const normalMealExtraGroups = category => [
    category.mealExtra1,
    category.mealExtra2,
    category.mealExtra3
].filter(Boolean)

const tableMealExtraIdFields = [
    'tableMealExtraId_1',
    'tableMealExtraId_2',
    'tableMealExtraId_3'
]

export const selectMealExtraGroups = (category, isTableOrder) => {
    if (!category) return []

    const normalGroups = normalMealExtraGroups(category)
    if (!isTableOrder) return normalGroups

    const hasTableSpecificContract = tableMealExtraIdFields.some(
        field => category[field] !== undefined
    )

    // Only old payloads without the new fields inherit the original groups.
    // Explicit null is a configured empty slot and must remain empty.
    if (!hasTableSpecificContract) return normalGroups

    return [
        category.tableMealExtra1,
        category.tableMealExtra2,
        category.tableMealExtra3
    ].filter(Boolean)
}
